import ReactNumberFormat from 'react-number-format';
import styled from 'styled-components';
import { rgba } from 'polished';

import { cFFFFFF } from '#/colors';
import useLabel from '#/utils/useLabel';
import {
  useOrderFormActions,
  useOrderFormView,
} from '#/features/options/order-builder/form-context';

import Field from '#/components/shared/Field';

export default function InputLimitPrice() {
  const formView = useOrderFormView();
  const formActions = useOrderFormActions();
  const [label, labelId] = useLabel('limit price');

  return (
    <Field label={label} labelId={labelId}>
      <NumberFormat
        id={labelId}
        thousandSeparator
        decimalScale={4}
        allowNegative={false}
        isNumericString
        placeholder="0"
        value={formView.limitPrice.value}
        onValueChange={({ value }) => formActions.updateLimitPrice(value)}
      />
      <Asset>{formView.quoteCurrency}</Asset>
    </Field>
  );
}

const NumberFormat = styled(ReactNumberFormat)`
  flex-grow: 1;
  height: 100%;
  background-color: transparent;
  border: none;
  color: ${cFFFFFF};
  font-size: 14px;
`;

const Asset = styled.span`
  font-size: 12px;
  color: ${rgba(cFFFFFF, 0.5)};
`;
